import CustomForm from "../CustomForm";
import ICustomFormSettings from "../ICustomFormSettings";
import CheckboxCell from "../shared/components/FormCell/CheckboxCell";
import {CheckboxItem} from "../../model/items/checkbox";
import {TextareaItem} from "../../model/items/textarea";
import {TextboxItem} from "../../model/items/textbox";

export default abstract class Upload extends CustomForm {

    protected readonly checkboxes: CheckboxCell[] = [];
    protected readonly filesMetadata!: TextareaItem;
    protected readonly filesCount: TextboxItem|null = null;


    constructor(settings: ICustomFormSettings) {
        super(settings);

        for (const cell of settings.form.grid.cells) {
            for (const cellItem of cell.cellItems) {
                if (cellItem instanceof CheckboxItem) {
                    this.checkboxes.push(new CheckboxCell(
                        cell,
                        this.onSetValue.bind(this),
                    ));
                } else if (!this.filesMetadata && cellItem instanceof TextareaItem) {
                    this.filesMetadata = cellItem;
                } else if (!this.filesCount && cellItem instanceof TextboxItem) {
                    this.filesCount = cellItem;
                }
            }
        }
    }

    public rewriteFormControls() {
        return true;
    }

    public checkRequirements(): boolean {
        return super.checkRequirements() && Boolean(this.filesMetadata);
    }

}
